import {easeOutCubic} from 'modules/ease.js';

export default function () {

    return easeOutCubic;
};
